<template>
  <v-card border>
    <template #title> {{ $t('dashboard.suggestions.title') }} </template>
    <template #text>
      <div class="dashboard-markero-suggestions">
        <div class="dashboard-markero-suggestions__content">
          <p class="mb-2">{{ $t('dashboard.suggestions.topics') }}</p>
          <div class="dashboard-markero-suggestions__content-actions">
            <v-btn
              color="primary"
              :to="{ path: '/topics' }"
            >
              {{ $t('dashboard.suggestions.topics-button') }}
            </v-btn>
          </div>
        </div>
        <div class="dashboard-markero-suggestions__content">
          <p class="mb-2">{{ $t('dashboard.suggestions.content') }}</p>
          <div class="dashboard-markero-suggestions__content-actions">
            <v-btn
              color="primary"
              :to="{ path: '/content-creator' }"
            >
              {{ $t('dashboard.suggestions.content-button') }}
            </v-btn>
          </div>
        </div>
      </div>
    </template>
  </v-card>
</template>
<style scoped>
.dashboard-markero-suggestions {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.dashboard-markero-suggestions__content {
  display: flex;
  flex-direction: column;
}
.dashboard-markero-suggestions__content-actions {
  display: flex;
  justify-content: end;
}
</style>
